module.exports = __webpack_public_path__ + "img/loads-3.3743b162.jpeg";